var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Message from "../message/Message";
import { Paper, TableContainer } from "@material-ui/core";
import _ from 'lodash';
import ToolBar from "../toolbar/ToolBar";
var useStyles = makeStyles(function (theme) { return ({
    listItemDataLi: {
        borderBottom: 'solid 1px #e0e0e0',
        '&:nth-child(odd)': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
    },
    labelValueDiv: {
        width: '100%',
        display: 'flex',
        borderBottom: 'solid 1px #e0e0e0',
        '& > div': {
            display: 'flex',
            alignItems: 'center'
        },
        '& > div:first-child': {
            width: '30%',
            maxWidth: 200,
            marginRight: theme.spacing(.5),
            padding: theme.spacing(1),
            justifyContent: 'flex-end',
            '& strong': {
                textAlign: 'right'
            }
        },
        '& > div:last-child': {
            flexGrow: 1,
            padding: theme.spacing(1)
        }
    }
}); });
function ListItemData(props) {
    var row = props.row, columns = props.columns;
    var classes = useStyles();
    return (React.createElement(React.Fragment, null, columns.map(function (column, columnIndex) {
        var value = column.valueGetter
            ? column.valueGetter(_.get(row, column.field), row)
            : _.get(row, column.field);
        return (React.createElement("div", { key: 'listItemData' + columnIndex, className: classes.labelValueDiv },
            React.createElement("div", null,
                React.createElement("strong", null, column.label)),
            React.createElement("div", null, value)));
    })));
}
export default function DataList(props) {
    var rows = props.rows, columns = props.columns, _a = props.comparatorKeys, comparatorKeys = _a === void 0 ? [] : _a, toolbarContent = props.toolbarContent, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.tableContainerProps, tableContainerProps = _c === void 0 ? {
        component: Paper
    } : _c;
    var classes = useStyles();
    var _d = useState(''), error = _d[0], setError = _d[1];
    var getComparatorValue = useCallback(function (row) {
        return comparatorKeys.reduce(function (accumulator, key) { return accumulator + row[key]; }, '');
    }, [comparatorKeys, comparatorKeys.length]);
    return (React.createElement(React.Fragment, null,
        !!toolbarContent && (React.createElement(ToolBar, { noBorderRadius: true }, toolbarContent)),
        !error && (React.createElement(TableContainer, __assign({}, tableContainerProps),
            React.createElement("ul", { className: className }, rows.map(function (row, rowIndex) { return (React.createElement("li", { key: getComparatorValue(row) ? 'rowKey' + getComparatorValue(row) : 'rowKey' + rowIndex, className: classes.listItemDataLi },
                React.createElement(ListItemData, { row: row, columns: columns }))); })))),
        !error && !rows.length && (React.createElement(Message, { type: 'info' }, "Nenhum registro encontrado.")),
        !!error && (React.createElement(Message, { type: 'error' }, error))));
}
